import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		VyrobekvozOzn: null as string | null,
		DniOd: null as number | null,
		DniDo: null as number | null,
		Pc: null as number | null,
		KmSazba: null as number | null,
		VozidlopaId: null as number | null,
		VozidloRzv: null as string | null,
		VozidloVin: null as string | null,
		TypMaska: null as string | null,
		TypMaskaText: null as string | null,
		ZakaznikSk: null as number | null,
		ZaznamId: null as number | null,
	},
	localState: {},
	props: {
		mode: null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.NAHRADNI_SAZBA_MASKA_MODELU_SELECT_MAPPER](state, { data }) {
			state.edit.TypMaska = data.value;
			state.edit.TypMaskaText = data.text;
		},
		[editMutations.NAHRADNI_SAZBA_VOZIDLO_PUJCOVNA_SELECT_MAPPER](state, { data }) {
			state.edit.VozidlopaId = data.id;
			state.edit.VozidloRzv = data.rzv;
			state.edit.VozidloVin = data.vin;
		},
	},
});
